/** RedVelvetTranslations resource ids: leading word char, then word chars, ':' or '-'. */
const PUFF_J_ID = /^\w[\w:-]*$/;

/**
 * Maps an i18next key (namespace already stripped) to a PUFF-J resource id: '.' → '_'. Throws
 * outside production on a key that doesn't round-trip, so misuse fails loudly rather than blanking.
 */
export function toArbId(key: string): string {
  const id = key.replace(/\./g, '_');
  if (!PUFF_J_ID.test(id) && process.env.NODE_ENV !== 'production') {
    throw new Error(`toArbId: key "${key}" does not map to a valid PUFF-J resource id ("${id}").`);
  }
  return id;
}

/**
 * Maps an option list's value code to the id fragment its label is keyed under, replacing every
 * character a PUFF-J id may not carry with '_' — `arabs@` reads `sponsors_arabs_`, and
 * `America/New_York` reads `America_New_York`. Separate from toArbId, which throws on those
 * characters because a dotted i18next key never legitimately contains them.
 */
export function toArbValueId(value: string): string {
  const id = value.replace(/[^\w:-]/g, '_');
  if (!PUFF_J_ID.test(id) && process.env.NODE_ENV !== 'production') {
    throw new Error(
      `toArbValueId: value "${value}" does not map to a valid PUFF-J resource id ("${id}").`
    );
  }
  return id;
}
